'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.test = undefined;

var _mapProps = require('recompose/mapProps');

var _mapProps2 = _interopRequireDefault(_mapProps);

var _omit = require('lodash/fp/omit');

var _omit2 = _interopRequireDefault(_omit);

var _setWrappedDisplayName = require('./setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = function enhancer(keys) {
  return (0, _mapProps2.default)((0, _omit2.default)(keys));
};

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'omitProps', true);


var test = { omit: _omit2.default };
exports.test = test;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/omitProps.js
// module id = 1728
// module chunks = 0